import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { NotificationsService } from 'angular2-notifications';
import { SessionStorageService } from 'ngx-webstorage';

import { FormControl } from '@angular/forms';

import { ResourcesService } from '../../../../services/resources/resources.service';
import { EventsService } from '../../../../services/events/events.service';
import { LocalStorageService } from 'ngx-webstorage';

import * as moment from 'moment-timezone';

@Component({
  selector: 'modal-survey-plan',
  styleUrls: [('./modalSurveyPlan.scss')],
  templateUrl: './modalSurveyPlan.html'
})

export class ModalSurveyPlan {

  modalHeader: string;
  private user: string = "";
  surveyPlan;
  personals;

  momentFrom;
  momentTo;
  dateRegister;

  dateChangeFrom = false;
  dateChangeTo = false;
  tipoH: string[] = [
    'Entrada',
    'Salida'
  ];
  public surveys = [];
  public surveySelected: FormControl;

  constructor(
    private activeModal: NgbActiveModal,
    private _notificationService: NotificationsService,
    private _sessionStorage: SessionStorageService,
    private _resourcesService: ResourcesService,
    private _localStorage: LocalStorageService,
    private _eventsService: EventsService
  ) {
    var user = _localStorage.retrieve('user_data');
    if (user != null)
      this.user = user;
      
    this.surveyPlan = {
      id_registro_horario: ('000' + user.id).slice(-4) +"-"+ moment().format("YYYYMMDDHHmmss"),
      id_usuario: ('000' + user.id).slice(-4),
      fecha: '',
      hora: '',
      id_personal: '',
      dni: '',
      legajo: '',
      tipo_registro: '',
      medio_registro: 1,
      cant_fotos: 1,
      gps_latitud: 0,
      gps_longitud: 0,
      gps_precision: 0,
      activo: true,
      id: ''
    };

    _resourcesService.getPersonal()
      .subscribe(
      (result) => { this.personals = result.results; console.log(this.personals); },
      (error) => console.log(error)
      );
  }

  ngOnInit() {

  }

  public addUpdateSurveyPlan() {
    console.log(this.surveyPlan)
    this._resourcesService.addRegistroHorario(this.surveyPlan)
      .subscribe(
      result => this.saveSurveyPlan(result),
      error => this.showError(error)
      );
  }

  private showError(error) {
    console.log(error)
    this._notificationService.error('Mensaje', 'Error con los datos ingresados.');
  }

  private saveSurveyPlan(surveyPlan) {
    this._eventsService.setObjectCrud(surveyPlan);
    this.activeModal.close();
  }

  public closeModal() {
    this.activeModal.close();
  }

  public setMoment(my_moment: any, model: string): any {
    if (model == 'fecha')
      this.dateChangeFrom = true;
    if (model == 'hora')
      this.dateChangeTo = true;
    if (my_moment != null) {
      if (model == 'fecha')
        this.surveyPlan[model] = moment(my_moment).format('YYYYMMDD');
      if (model == 'hora')
        this.surveyPlan[model] = moment(my_moment).format('HHmm')+'00';
    } else {
      this.surveyPlan[model] = null;
    }

  }

}



// WEBPACK FOOTER //
// /app/src/app/theme/components/modals/components/modalSurveyPlan/modalSurveyPlan.component.ts